import { render, staticRenderFns } from "./expense-card-info.vue?vue&type=template&id=1dc0e7b2&"
import script from "./expense-card-info.vue?vue&type=script&lang=js&"
export * from "./expense-card-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports